module.exports = __webpack_public_path__ + "media/images/flags/4x3/lka-1ffbc3865ecc15c1da2726ef046612cc.svg";